import { render } from "./IconClick.vue?vue&type=template&id=6b9ec00a"
import script from "./IconClick.vue?vue&type=script&lang=js"
export * from "./IconClick.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__